module.exports = __webpack_public_path__ + "static/media/keeta.6dbcdfd0.png";